/**
 * main.ts — Entry point do SpaceWar Web.
 *
 * Responsabilidades:
 *   1. Encontrar o container raiz (#app)
 *   2. Instanciar Game
 *   3. Iniciar
 *
 * Toda logica nos modulos. Esse arquivo deve permanecer curto.
 */

// CSP do games.ensinosocial.com.br e `script-src 'self'` (sem 'unsafe-eval'): o PixiJS gera o sync
// de uniforms/shaders com `new Function` e estoura ao criar o renderer ("Current environment does
// not allow unsafe-eval"). Este modulo troca essa geracao por polyfills sem eval. TEM que vir antes
// de qualquer `new Application()`; e o que manteve o jogo preso no splash de 09 a 27/09/2026.
import 'pixi.js/unsafe-eval';
import { Game } from './core/Game';

const raiz = document.getElementById('app');
if (!raiz) {
  throw new Error('Container raiz #app nao encontrado no DOM.');
}

const jogo = new Game(raiz);
jogo.iniciar();

if (import.meta.env.DEV) {
  (window as unknown as { __jogo: Game }).__jogo = jogo;
  console.log('[SpaceWar] Jogo iniciado. Debug: window.__jogo');
}
